import { render, staticRenderFns } from "./recharge1.vue?vue&type=template&id=5c2ad0f8&scoped=true"
import script from "./recharge1.vue?vue&type=script&lang=js"
export * from "./recharge1.vue?vue&type=script&lang=js"
import style0 from "./recharge1.vue?vue&type=style&index=0&id=5c2ad0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2ad0f8",
  null
  
)

export default component.exports